import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-restart",
  "use": "foquz-icon-restart-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" id=\"foquz-icon-restart\"><path d=\"M13.734 12.015a7 7 0 11-.144-8.228\" stroke=\"#FCC072\" stroke-width=\"2\" stroke-linecap=\"round\" /><path d=\"M15 2v3h-3\" stroke=\"#FCC072\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol